module.exports = __webpack_public_path__ + "static/img/php-vision.889e23c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/php-vision.jpg
 ** module id = 53
 ** module chunks = 1
 **/